module.exports = __webpack_public_path__ + "static/media/fruit_party.pragmaticplay.67653dc2.jpeg";